import { snakeCaseToTitleCase } from '@agilelab/plugin-wb-platform-common';
import { Typography, MenuItem, makeStyles } from '@material-ui/core';
import { FC, useEffect } from 'react';
import { useEnvironmentsContext } from '../../context/EnvironmentsContext';
import { WbSelectInline, WbSelectInlineItem } from '../WbSelectInline';
import { WbSelect } from '../WbTextField/WbSelect';
import { useResponsiveMobile } from '../WbSidebar/useResponsiveMobile';

interface Props {
  disabled?: boolean;
  defaultValue?: string;
  onChange?: (e: string) => void;
}

const useStyles = makeStyles(() => {
  return {
    inputStyle: {
      minHeight: 'auto',
      backgroundColor: 'white',
    },
  };
});

export const WbEnvironmentSelector: FC<Props> = ({ disabled, onChange }) => {
  const {
    environmentList,
    environment,
    setEnvironment,
    disabledStatus,
    setDisabledStatus,
  } = useEnvironmentsContext();
  useEffect(
    () => setDisabledStatus(disabled ?? false),
    [disabled, setDisabledStatus],
  );

  const isMobile = useResponsiveMobile();
  const classes = useStyles();

  if (!environmentList.length) {
    return <></>;
  }

  if (isMobile) {
    return (
      <WbSelect
        label="Environment"
        id="environment-selector"
        value={environment.name}
        disabled={disabledStatus || environmentList.length === 1}
        onChange={e => {
          const value = e.target.value as string;
          setEnvironment(environmentList.find(env => env.name === value)!);
          if (onChange) onChange(value);
        }}
        clearable={false}
        InputProps={{
          classes: {
            root: classes.inputStyle,
          },
        }}
        style={{
          minHeight: 'auto',
        }}
      >
        {environmentList.map(e => (
          <MenuItem key={e.name} value={e.name}>
            {snakeCaseToTitleCase(e.name)}
          </MenuItem>
        ))}
      </WbSelect>
    );
  }

  return (
    <WbSelectInline
      title="Environment:"
      menuTitle="Environments"
      value={environment.name}
      disabled={disabledStatus || environmentList.length === 1}
      onChange={e => {
        setEnvironment(environmentList.find(env => env.name === e)!);

        if (onChange) onChange(e);
      }}
    >
      {environmentList.map(e => (
        <WbSelectInlineItem {...{ key: e.name, value: e.name }}>
          <Typography variant="body2">
            {snakeCaseToTitleCase(e.name)}
          </Typography>
        </WbSelectInlineItem>
      ))}
    </WbSelectInline>
  );
};
